<template>
  <v-app>
      <router-view />
      <footerComponent />
  </v-app>
</template>

<script>
import footerComponent from "@/components/footerComponent.vue";
export default {
  name: "store.kahon.app",
  components: {
    footerComponent
  },
  data: () => ({
    //
  })
};
</script>

<style>
* {
  font-family: "Work Sans", sans-serif !important;
  font-display: swap;
}
</style>